__turbopack_context__.v({
  "breadcrumbs": "style-module-scss-module__DmRtDq__breadcrumbs",
  "breadcrumbsWrap": "style-module-scss-module__DmRtDq__breadcrumbsWrap",
  "content": "style-module-scss-module__DmRtDq__content",
  "title": "style-module-scss-module__DmRtDq__title",
  "wrapper": "style-module-scss-module__DmRtDq__wrapper",
});
